<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-irondome-box">
  <!-- Artboard: xs -->
  <div
    id="g-irondome-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.47826086956522;"
  >
    <div
      id="g-irondome-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/irondome-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs"
      style="top:1.0145%;left:1.3293%;width:60.6061%;"
    >
      <p>
        <span class="g-cstyle0">Iron Dome</span> is a mobile system designed to intercept
        short-range rockets and artillery shells that endanger populated areas in
        Israel.
      </p>
    </div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.496%;margin-top:-24.6px;left:70.1879%;width:82px;"
    >
      <p class="g-pstyle0">Iranian</p>
      <p class="g-pstyle0">incoming</p>
      <p class="g-pstyle0">rockets</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:20.525%;margin-top:-24.6px;left:19.0143%;width:94px;"
    >
      <p class="g-pstyle1">Israeli</p>
      <p class="g-pstyle1">interceptor</p>
      <p class="g-pstyle1">missile</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:41.2496%;margin-top:-8.6px;left:57.8709%;width:88px;"
    >
      <p class="g-pstyle1">Israeli city</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.8983%;margin-top:-13.5px;left:1.5283%;width:65px;"
    >
      <p class="g-pstyle2">Missile</p>
      <p class="g-pstyle2">launcher</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.1157%;margin-top:-13.5px;left:54.9923%;width:120px;"
    >
      <p class="g-pstyle2">Battle management</p>
      <p class="g-pstyle2">and weapon control</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:74.1302%;margin-top:-13.5px;left:2.3113%;width:111px;"
    >
      <p class="g-pstyle2">*The drawings are</p>
      <p class="g-pstyle2">not to scale.</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:83.5504%;margin-top:-13.5px;left:54.9923%;width:91px;"
    >
      <p class="g-pstyle2">Detection and</p>
      <p class="g-pstyle2">tracking radar</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:89.2754%;left:1.3293%;width:94.8485%;"
    >
      <p>
        <span class="g-cstyle1">Each battery</span> &ndash; a combination of
        missile launcher, control station and radar &ndash;
        <span class="g-cstyle1">can defend about 150 square kilometres</span> (58
        square miles), about the size of a medium-sized city.
      </p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-irondome-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.64968152866242;"
  >
    <div
      id="g-irondome-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/irondome-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs"
      style="top:0.8917%;left:0.664%;width:46.4706%;"
    >
      <p>
        <span class="g-cstyle0">Iron Dome</span> is a mobile system designed to intercept
        short-range rockets and artillery shells that endanger populated areas in
        Israel.
      </p>
    </div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.8691%;margin-top:-24.6px;left:62.6706%;width:82px;"
    >
      <p class="g-pstyle0">Iranian</p>
      <p class="g-pstyle0">incoming</p>
      <p class="g-pstyle0">rockets</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.5124%;margin-top:-24.6px;left:27.2053%;width:94px;"
    >
      <p class="g-pstyle1">Israeli</p>
      <p class="g-pstyle1">interceptor</p>
      <p class="g-pstyle1">missile</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:39.4424%;margin-top:-11.6px;left:60.0396%;width:88px;"
    >
      <p class="g-pstyle2">Israeli city</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.2842%;margin-top:-14.6px;left:9.9261%;width:72px;"
    >
      <p class="g-pstyle3">Missile</p>
      <p class="g-pstyle3">launcher</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.6536%;margin-top:-14.6px;left:57.4793%;width:137px;"
    >
      <p class="g-pstyle3">Battle management</p>
      <p class="g-pstyle3">and weapon control</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:78.9275%;margin-top:-14.6px;left:10.6225%;width:125px;"
    >
      <p class="g-pstyle3">*The drawings are</p>
      <p class="g-pstyle3">not to scale.</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs"
      style="top:84.9682%;left:0.664%;width:38.8235%;"
    >
      <p>
        <span class="g-cstyle1">Each battery</span> &ndash; a combination of
        missile launcher, control station and radar &ndash;
        <span class="g-cstyle1">can defend about 150 square kilometres</span> (58
        square miles), about the size of a medium-sized city.
      </p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.6154%;margin-top:-14.6px;left:57.4793%;width:102px;"
    >
      <p class="g-pstyle3">Detection and</p>
      <p class="g-pstyle3">tracking radar</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-irondome-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.76744186046512;"
  >
    <div
      id="g-irondome-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/irondome-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs"
      style="top:0.4651%;left:0.0586%;width:25.303%;"
    >
      <p>
        <span class="g-cstyle0">Iron Dome</span> is a mobile system designed to intercept
        short-range rockets and artillery shells that endanger populated areas in
        Israel.
      </p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.5888%;margin-top:-9.7px;left:28.567%;width:197px;"
    >
      <p class="g-pstyle0">Israeli interceptor missile</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:1.5888%;margin-top:-9.7px;left:63.8354%;width:193px;"
    >
      <p class="g-pstyle1">
        Iranian<span class="g-cstyle1"> </span>incoming<span class="g-cstyle1">
        </span>rockets
      </p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.5074%;margin-top:-8.2px;left:59.9343%;width:93px;"
    >
      <p class="g-pstyle2">Israeli city</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.9978%;margin-top:-15.6px;left:82.8368%;width:125px;"
    >
      <p class="g-pstyle3">*The drawings are</p>
      <p class="g-pstyle3">not to scale.</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.4629%;margin-top:-15.6px;left:10.0126%;width:72px;"
    >
      <p class="g-pstyle3">Missile</p>
      <p class="g-pstyle3">launcher</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.2536%;margin-top:-15.6px;left:57.3074%;width:137px;"
    >
      <p class="g-pstyle3">Battle management</p>
      <p class="g-pstyle3">and weapon control</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs"
      style="top:79.3023%;left:0.0586%;width:31.5152%;"
    >
      <p>
        <span class="g-cstyle2">Each battery</span> &ndash; a combination of
        missile launcher, control station and radar &ndash;
        <span class="g-cstyle2">can defend about 150 square kilometres</span> (58
        square miles), about the size of a medium-sized city.
      </p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.5094%;margin-top:-15.6px;left:57.3074%;width:102px;"
    >
      <p class="g-pstyle3">Detection and</p>
      <p class="g-pstyle3">tracking radar</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-irondome-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.90731707317073;"
  >
    <div
      id="g-irondome-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/irondome-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:3.0891%;margin-top:-27.7px;left:74.3348%;width:86px;"
    >
      <p class="g-pstyle0">Iranian</p>
      <p class="g-pstyle0">incoming</p>
      <p class="g-pstyle0">rockets</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs"
      style="top:5.6585%;left:2.1921%;width:15.914%;"
    >
      <p>
        <span class="g-cstyle0">Iron Dome</span> is a mobile system designed to intercept
        short-range rockets and artillery shells that endanger populated areas in
        Israel.
      </p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.3575%;margin-top:-27.7px;left:27.5314%;width:99px;"
    >
      <p class="g-pstyle1">Israeli</p>
      <p class="g-pstyle1">interceptor</p>
      <p class="g-pstyle1">missile</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:35.8697%;margin-top:-9.7px;left:54.1458%;width:93px;"
    >
      <p class="g-pstyle1">Israeli city</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.203%;margin-top:-14.6px;left:81.1015%;width:125px;"
    >
      <p class="g-pstyle2">*The drawings are</p>
      <p class="g-pstyle2">not to scale.</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:71.5729%;margin-top:-18.6px;left:14.3273%;width:76px;"
    >
      <p class="g-pstyle3">Missile</p>
      <p class="g-pstyle3">launcher</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:79.3778%;margin-top:-18.6px;left:54.7495%;width:145px;"
    >
      <p class="g-pstyle3">Battle management</p>
      <p class="g-pstyle3">and weapon control</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs"
      style="top:82.3415%;left:15.3872%;width:27.2043%;"
    >
      <p>
        <span class="g-cstyle1">Each battery</span> &ndash; a combination of
        missile launcher, control station and radar &ndash;
        <span class="g-cstyle1">can defend about 150 square kilometres</span> (58
        square miles), about the size of a medium-sized city.
      </p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.8168%;margin-top:-18.6px;left:54.7495%;width:108px;"
    >
      <p class="g-pstyle3">Detection and</p>
      <p class="g-pstyle3">tracking radar</p>
    </div>
  </div>
</div>
<!-- End ai2html - 2025-06-17 12:39 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-17 12:39 -->
<!-- ai file: irondome.ai -->
<style lang="scss">
  #g-irondome-box,
  #g-irondome-box .g-artboard {
    margin: 0 auto;
  }
  #g-irondome-box p {
    margin: 0;
  }
  #g-irondome-box .g-aiAbs {
    position: absolute;
  }
  #g-irondome-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-irondome-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-irondome-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-irondome-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-irondome-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-irondome-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-irondome-lg {
        display: block !important;
      }
    }
  }
  #g-irondome-xs {
    position: relative;
    overflow: hidden;
  }
  #g-irondome-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-irondome-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-irondome-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    color: rgb(165, 15, 21);
  }
  #g-irondome-xs .g-pstyle2 {
    font-weight: 300;
    line-height: 13px;
    height: 13px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-irondome-xs .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-irondome-xs .g-cstyle1 {
    font-weight: 700;
  }
  #g-irondome-sm {
    position: relative;
    overflow: hidden;
  }
  #g-irondome-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-irondome-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
  }
  #g-irondome-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    color: rgb(165, 15, 21);
  }
  #g-irondome-sm .g-pstyle2 {
    font-weight: 700;
    line-height: 22px;
    height: 22px;
    color: rgb(165, 15, 21);
  }
  #g-irondome-sm .g-pstyle3 {
    font-weight: 300;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-irondome-sm .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-irondome-sm .g-cstyle1 {
    font-weight: 700;
  }
  #g-irondome-md {
    position: relative;
    overflow: hidden;
  }
  #g-irondome-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-irondome-md .g-pstyle0 {
    font-weight: 700;
    height: 18px;
    color: rgb(165, 15, 21);
  }
  #g-irondome-md .g-pstyle1 {
    font-weight: 700;
    height: 18px;
  }
  #g-irondome-md .g-pstyle2 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
    color: rgb(165, 15, 21);
  }
  #g-irondome-md .g-pstyle3 {
    font-weight: 300;
    line-height: 15px;
    height: 15px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-irondome-md .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-irondome-md .g-cstyle1 {
    font-weight: 400;
  }
  #g-irondome-md .g-cstyle2 {
    font-weight: 700;
  }
  #g-irondome-lg {
    position: relative;
    overflow: hidden;
  }
  #g-irondome-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-irondome-lg .g-pstyle0 {
    font-weight: 700;
    height: 18px;
  }
  #g-irondome-lg .g-pstyle1 {
    font-weight: 700;
    height: 18px;
    color: rgb(165, 15, 21);
  }
  #g-irondome-lg .g-pstyle2 {
    font-weight: 300;
    line-height: 14px;
    height: 14px;
    font-size: 14px;
    color: rgb(102, 102, 102);
  }
  #g-irondome-lg .g-pstyle3 {
    font-weight: 300;
    height: 18px;
    font-size: 15px;
    color: rgb(102, 102, 102);
  }
  #g-irondome-lg .g-cstyle0 {
    font-weight: 700;
    color: rgb(165, 15, 21);
  }
  #g-irondome-lg .g-cstyle1 {
    font-weight: 700;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
